import { render, staticRenderFns } from "./DetailMobile.vue?vue&type=template&id=1916a7a4&scoped=true"
import script from "./DetailMobile.vue?vue&type=script&lang=js"
export * from "./DetailMobile.vue?vue&type=script&lang=js"
import style0 from "./DetailMobile.vue?vue&type=style&index=0&id=1916a7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916a7a4",
  null
  
)

export default component.exports